import request from '@/network/http'

export function getUserList(data) {
    return request({
        url: 'Users/OrganizationUsers/getUserList',
        method: 'post',
        data
    })
}

export function getExpertOrganizationList(data) {
    return request({
        url: 'Users/ExpertUsers/getExpertOrganizationList',
        method: 'post',
        data
    })
}

export function getExpertMajorList() {
    return request({
        url: 'Base/CheckupProject/getExpertMajorList',
        method: 'post',
        
    })
}

export function getExpertDetail(data) {
    return request({
        url: 'Users/ExpertUsers/getExpertDetail',
        method: 'post',
        data
    })
}

export function saveExpertOrganizationInfo(data) {
    return request({
        url: 'Users/ExpertUsers/saveExpertOrganizationInfo',
        method: 'post',
        data
    })
}

export function deleteExpertOrganizationInfo(data) {
    return request({
        url: 'Users/ExpertUsers/deleteExpertOrganizationInfo',
        method: 'post',
        data
    })
}

export function saveUserInfo(data) {
    return request({
        url: 'Users/OrganizationUsers/saveUserInfo',
        method: 'post',
        data
    })
}

export function deleteUserInfo(data) {
    return request({
        url: 'Users/OrganizationUsers/deleteUserInfo',
        method: 'post',
        data
    })
}

export function getExpertOrganizationDetail(data) {
    return request({
        url: 'Users/ExpertUsers/getExpertOrganizationDetail',
        method: 'post',
        data
    })
}

export function getUserDetail(data) {
    return request({
        url: 'Users/OrganizationUsers/getUserDetail',
        method: 'post',
        data
    })
}




// WEBPACK FOOTER //
// ./src/apis/person.js